import { fetcher } from "helpers/fetcher";

import { TDeleteStaffInsuranceReq, TDeleteStaffInsuranceRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const deleteStaffInsurance = async (
  payload: TDeleteStaffInsuranceReq
) => {
  return await fetcher<
    TDeleteStaffInsuranceRes,
    TDeleteStaffInsuranceReq["data"]
  >(ENDPOINT.USER.DELETE_STAFF_INSURANCE, {
    data: payload.data,
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.USER.DELETE_STAFF_INSURANCE.version,
      [API_HEADER.USER_ID]: payload.idUser,
    },
  });
};

export const mutationDeleteStaffInsurance = async (
  payload: TDeleteStaffInsuranceReq
) => {
  return (await deleteStaffInsurance(payload)).data.message;
};

mutationDeleteStaffInsurance._key = (payload: TDeleteStaffInsuranceReq) => [
  ENDPOINT.USER.DELETE_STAFF_INSURANCE.url,
  payload,
];
